module.exports = __webpack_public_path__ + "img/bacon_cheddar.b6d1fb78.jpeg";